import { put, takeEvery } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import { checkOrgSuccess, checkOrgFailed } from '../actions';
import { OrganizationTypes } from '../types';

const { API_BASE_URL } = urls || {};

export function* checkOrgExistence({ data: { id, cb } }) {
  const url = `${API_BASE_URL}/organisation/${id}`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success && response.statusCode === 200) {
    yield put(checkOrgSuccess());
    cb(response.raw)
    return;
  }
  if (response.statusCode === 404) yield put(checkOrgFailed());
}

export function* orgCheck() {
  yield takeEvery(OrganizationTypes.CHECK_ORG_EXISTS, checkOrgExistence);
}
